

<ng-container *ngIf="dataSource?.length && +dataSource[1].Value !== 0">
  <div class="w-full px-2">
    <!-- <mat-slider class="!w-full"  min="{{dataSource[0].Value}}" max="{{dataSource[1].Value}}">
            <input value="{{minValue()}}" (input)="changeMinVal($event)" (pointerup)="minValueChanged($event)" matSliderStartThumb>
            <input value="{{maxValue()}}" (input)="changeMaxVal($event)" (pointerup)="maxValueChanged($event)" matSliderEndThumb>
          </mat-slider> -->
    <iho-sliderange
      [min]="+dataSource[0].Value"
      [max]="+dataSource[1].Value"
      [_minValue]="_minValue"
      [_maxValue]="_maxValue"
      [reset]="reset()"
      (minValueChanged)="minValueChanged($event)"
      (maxValueChanged)="maxValueChanged($event)"
      (minValueChanging)="changeMinVal($event)"
      (maxValueChanging)="changeMaxVal($event)"></iho-sliderange>
  </div>
  <div class="w-full flex justify-between items-center px-2 mt-3">
    <div class>
      <span>از</span>
      <span *ngIf="+minValue() !== 0;else minzero" class="mx-1 text-base text-black-500">{{minValue() | toToman |
        number: '2.'}}</span>
      <ng-template #minzero>
        <span class="mx-1 text-base text-black-500">{{minValue() | toToman}}</span>
      </ng-template>
      <span class="text-black-300 text-sm">تومان</span>
    </div>
    <div class>
      <span>تا</span>
      <span class="mx-1 text-base text-black-500">{{maxValue() | toToman |
        number: '2.'}}</span>
      <span class="text-black-300 text-sm">تومان</span>
    </div>
  </div>
</ng-container>
